import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import SideBar from "./SideBar";
import { loader } from "../redux/type";
import { registerNewUser } from "../Services/getServices";
import { pincodeList } from "../Services/getServices";
import { localityList } from "../Services/getServices";
import { districtList } from "../Services/getServices";
import { domainList } from "../Services/getServices";
import { LoginUser } from "../Services/authServices";
import { toast } from "react-toastify";
import { auth } from "../redux/type";

const MyProfile = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  // const mobNum = useLocation().state?.mobNo;

  const mobNum=localStorage.getItem("moblie")
  // console.log("MobileNum=", mob99);

  var [tit, setTit] = useState("");
  var [firstName, setFirstName] = useState("");
  var [middleName, setMiddleName] = useState("");
  var [lastName, setLastName] = useState("");
  var [fatherName, setFatherName] = useState("");
  var [aadhaarNo, setAadhaarNo] = useState("");
  var [mobileNo, setMobileNo] = useState("");
  var [panNo, setPanNo] = useState("");
  var [email, setEmail] = useState("");
  var [gender, setGender] = useState("");
  var [dob, setDob] = useState("");
  var [consumerId, setConsumerId] = useState("");
  var [property, setProperty] = useState("");
  var [createUser, setCreateUser] = useState("");
  var [password, setPassword] = useState("");
  var [pincode, setPincode] = useState("");
  var [district, setDistrict] = useState("");
  var [locality, setLocality] = useState("");
  var [pincodeListData, setPincodeListData] = useState([]);
  var [districtListData, setDistrictListData] = useState([]);
  var [localityListData, setLocalityListData] = useState([]);
  var [addressUser, setAddressUser] = useState("");

  useEffect(() => {
    pincodeL();
    domain();
  }, []);

  function submitSsoLogin() {
    dispatch({ type: loader.startLoader });
    LoginUser(createUser, password, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        console.log(res.data.token);
        localStorage.setItem("userType", 0);
        localStorage.setItem("token", res?.data?.token);
         dispatch({
                    type: auth.login,
                    payload: res?.data?.userdetail,
                  });
        navigate("/citizendashboard");
        window.location.reload();
      } else {
        console.log("stop");
      }
    });
  }

  function domain() {
    dispatch({ type: loader.startLoader });
    domainList((res) => {
      dispatch({ type: loader.stopLoader });
      if (res.status) {
        // setPincodeListData(res.data.result);
        console.log(res);
      } else {
        console.log(res);
      }
    });
  }
  function pincodeL() {
    dispatch({ type: loader.startLoader });
    pincodeList((res) => {
      dispatch({ type: loader.stopLoader });
      if (res.status) {




        setPincodeListData(res.data.result);
      } else {
        console.log(res);
      }
    });
  }

  function localityL(pin) {

    dispatch({ type: loader.startLoader });
    localityList(pin, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.status) {
        setLocalityListData(res?.data?.result);
        console.log("setLocalityListData=",res?.data?.result)
        
      } else {
        console.log(res);
      }
    });
  }
  function districtL(pin) {

    dispatch({ type: loader.startLoader });
    districtList(pin, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.status) {
       
        setDistrictListData(res.data.result);
      } else {
        console.log(res);
      }
    });
  }

  console.log("GENDER", dob);

  var req = {
    // "userId":createUser,
    userName: createUser,
    panCard: panNo,
    emailId: email,
    title: tit,
    mobileNumber: mobNum,
    aadharNo: aadhaarNo,
    firstName: firstName,
    middleName: middleName,
    lastName: lastName,
    dob: dob,
    gender: gender,
    address: addressUser,
    // "domainCode": "IT",
    // "city": "New York",
    pinCode: pincode,
    // "designation": "Software Engineer",
    consumerId: consumerId,
    // "consumerName": "ABC Consumer",
    // "medicalCardNo": "MED123456",
    // "userType": "Admin",
    // "consumerId": "C12345",
    password: password,
    retypePassword: password,
    // "officeAddress": "456 Office St, New York",
    fathersNameOfApplicant: fatherName,
    typeOfProperty: property,
    // "branch": "NYC"
  };

  function registerUser() {
   
     if(mobNum==="" | mobNum===null){
      toast.error("Mobile Number Not Found");
      return;

    }
    else if(firstName===""){
      toast.error("Fill First Name");
      return;
    }
    else if(lastName===""){
      toast.error("Fill Last Name");
      return;

    }else if(gender===""){
      toast.error("Select Gender");
      return;
    }else if(email===""){
      toast.error("Fill Email");
      return;
    }else if(createUser===""){
      toast.error("Create User Name");
      return;
    }
    else if(password===""){
      toast.error("Fill Password");
      return;
    }

    dispatch({ type: loader.startLoader });


    registerNewUser(req, (res) => {
      dispatch({ type: loader.stopLoader });
      if (res?.data?.status) {
        toast.success("Profile Created successfully");
        submitSsoLogin();
       
      } else {
        toast.error(res?.data?.message)
       
      }
    });
  }

  return (
    <>
      {/* <SideBar /> */}
      <div className="card shadow myprofileCard ">
        <div className="card-body overFlow p-md-3">
          <h4 className="h2_heading" onClick={districtL}>
            Register
          </h4>

          <div className="row justify-content-around ">
            <div className="col-2">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Title:
                </label>
                <select
                  className="form-control form-select"
                  onChange={(e) => setTit(e.target.value)}
                >
                  <option value="">Select Title</option>
                  <option value="Mr">Mr</option>
                  <option value="Mrs">Mrs</option>
                  <option value="Miss">Miss</option>
                </select>
                {/* <input
                  type="mobile"
                  id="aadhaarcard"
                  className="form-control"
                  placeholder="Enter here"
                /> */}
              </div>
            </div>
            <div className="col-3">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  First Name:
                </label>
                <input
                  type="mobile"
                  id="aadhaarcard"
                  onChange={(e) => setFirstName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                  required
                />
              </div>
            </div>
            <div className="col-2">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Middle Name:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setMiddleName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>

            <div className="col-2">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Last Name:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setLastName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-2">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Father Name:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setFatherName(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
          </div>

          <div className="row justify-content-around ">
            <div className="col-3">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Mobile Number:
                </label>
                <input
                  type="mobile"
                  // onChange={(e) => setMobileNo(e.target.value)}
                  value={mobNum}
                  disabled
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            {/* <div className="col-2">
              <div className="form-outline mb-3">
                <button type="btn" className="btn btn-primary marTopButton">
                  Send OTP
                </button>
              </div>
            </div> */}
            <div className="col-3">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Aadhaar Number:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setAadhaarNo(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>

            {/* <div className="col-2">
              <div className="form-outline mb-3 ">
                <button type="btn" className="btn btn-primary marTopButton">
                  Send OTP
                </button>
              </div>
            </div> */}

            <div className="col-3">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Pancard Number:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setPanNo(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>

            <div className="col-3">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Email:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
          </div>

          {/* <div className="row justify-content-around ">
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Pancard Number:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setPanNo(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-2">
              <div className="form-outline mb-3">
                <button type="btn" className="btn btn-primary marTopButton">
                  Send OTP
                </button>
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Email:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setEmail(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>

            <div className="col-2">
              <div className="form-outline mb-3 ">
                <button type="btn" className="btn btn-primary marTopButton">
                  Send OTP
                </button>
              </div>
            </div>
          </div> */}

          <div className="row justify-content-around ">
            <div className="col-3">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Gender:
                </label>
                <select
                  className="form-control "
                  onChange={(e) => setGender(e.target.value)}
                >
                  <option value="none">Select Gender</option>
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                  <option value="Trans">Transgender</option>
                </select>
              </div>
            </div>
            <div className="col-3">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  DOB:
                </label>
                <input
                  type="date"
                  onChange={(e) => setDob(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-3">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Consumer Id:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setConsumerId(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>

            <div className="col-3">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Type of property:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setProperty(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
          </div>

          <div className="row justify-content-around ">
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  PinCode:
                </label>

                <select
                  class="form-control form-select"
                  onChange={(e) => {
                    setPincode(e.target.value);
                    districtL(e.target.value);
                    localityL(e.target.value);
                  }}
                  placeholder="Pincode"
                >
                  <option value="0">Select Pincode </option>

                  {pincodeListData.map((val) => {
                    return (
                      <option key={val} value={val}>
                        {val}
                      </option>
                    );
                  })}
                </select>
                {/* <input
                  type="mobile"
                  onChange={(e) => setPincode(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                /> */}
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  District:
                </label>
                <select
                  class="form-control form-select"
                  onChange={(e) => setDistrict(e.target.value)}
                  placeholder="District"
                >
                  <option value="0">Select District </option>

                  {districtListData.map((val, key) => {
                    return (
                      <option key={key} value={val.districtCode}>
                        {val.districtName}
                      </option>
                    );
                  })}
                </select>

                {/* <input
                  type="mobile"
                  onChange={(e) => setDistrict(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                /> */}
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Locality:
                </label>

                <select
                  class="form-control form-select"
                  onChange={(e) => setLocality(e.target.value)}
                  placeholder="Locality"
                >
                  <option value="0">Select Locality </option>

                  {localityListData.map((val, key) => {
                    return (
                      <option key={key} value={val.newLocalityId}>
                        {val.localityName}
                      </option>
                    );
                  })}
                </select>

                {/* <input
                  type="mobile"
                  onChange={(e) => setLocality(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                /> */}
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Address:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setAddressUser(e.target.value)}
                  className="form-control"
                  placeholder="write your full address here"
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3">
                <label className="form-label" for="id">
                  Create Username:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setCreateUser(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
            <div className="col-4">
              <div className="form-outline mb-3 ">
                <label className="form-label" for="id">
                  Create Password:
                </label>
                <input
                  type="mobile"
                  onChange={(e) => setPassword(e.target.value)}
                  className="form-control"
                  placeholder="Enter here"
                />
              </div>
            </div>
          </div>

          <div className="row justify-content-around ">
            <div className="col-2">
              <div className="form-outline mb-3">
                {/* <Link to="/citizendashboard"> */}

                <button
                  type="btn"
                  className="btn btn-primary "
                  // onClick={registerUser}
                  onClick={(e) => {
                    registerUser();
                    // submitSsoLogin();
                  }}
                >
                  Procced
                </button>
                {/* </Link> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MyProfile;
